export default __webpack_public_path__ + "static/media/screen5.8cf65990.png";